import { memo } from 'react';
import { twMerge } from 'tailwind-merge';

interface SpinnerProps {
  className?: string;
  containerClassName?: string;
  color?: string;
}

const _Spinner = ({
  className,
  containerClassName,
  color = 'border-spinner_primary'
}: SpinnerProps) => {
  return (
    <div
      className={twMerge(
        'flex w-full items-center justify-center overflow-hidden',
        containerClassName
      )}>
      <span
        className={twMerge(
          color,
          'box-border block h-[48px] w-[48px] animate-spin rounded-[50%] border-[5px] border-b-[transparent]',
          className
        )}></span>
    </div>
  );
};

export const Spinner = memo(_Spinner);
